module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_1.02147397.png";